import React from "react";

import Header from "./Components/Header";
import Footer from "./Components/Footer";

const AboutUs = () => {
return(
    <div>
        <Header/>
        <main id="main">
            <section id="breadcrumbs" class="breadcrumbs">
                <div class="container">
                    <div class="d-flex justify-content-between align-items-center">
                        <h2>About</h2>
                        <ol>
                            <li><a href="index.html">Home</a></li>
                            <li>About</li>
                        </ol>
                    </div>
                </div>
            </section>
            <section id="about-us" class="about-us">
                <div class="container" data-aos="fade-up">
                    <div class="row content">
                        <div class="col-lg-6" data-aos="fade-right">
                            <h2>Trusted Civil & Structural Engineering Solutions</h2>
                            <h3>Delivering reliable civil and structural engineering solutions with safety, efficiency, and precision.</h3>
                        </div>
                        <div class="col-lg-6 pt-4 pt-lg-0" data-aos="fade-left">
                            <p>
                            We deliver trusted civil and structural engineering solutions designed to move your project forward with confidence. From planning to execution, our team ensures every step is handled with safety, efficiency, and precision.
                            </p>
                            <ul>
                                <li><i class="ri-check-double-line"></i> Comprehensive civil and structural engineering services</li>
                                <li><i class="ri-check-double-line"></i> Safe, efficient, and code-compliant project delivery</li>
                                <li><i class="ri-check-double-line"></i> Experienced teams dedicated to quality and innovation</li>
                            </ul>
                            <p class="fst-italic">Our mission is simple: to build strong foundations for communities and lasting value for our clients.</p>
                        </div>
                    </div>
                </div>
            </section>
            <section id="team" class="team section-bg">
                <div class="container">
                    <div class="section-title" data-aos="fade-up">
                        <h2>Our <strong>Team</strong></h2>
                        <p>Our team is made up of experienced civil, structural, and MEP engineers, architects, and project managers who work together to bring every project from concept to completion. With a commitment to safety, precision, and innovation, we ensure that every design and construction phase meets the highest standards of quality. Guided by collaboration and expertise, we deliver solutions that are reliable, sustainable, and built to last.</p>
                    </div>
                    <div class="row">
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                        <div class="member" data-aos="fade-up" data-aos-delay="100">
                            <div class="member-img">
                                <img src="assets/images/team/team-2.jpg" class="img-fluid" alt=""/>
                                
                            </div>
                            <div class="member-info">
                                <h4>Richard Garza</h4>
                                <span>CTO</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                        <div class="member" data-aos="fade-up" data-aos-delay="200">
                            <div class="member-img">
                                <img src="assets/images/team/team-3.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="member-info">
                                <h4>Saady Amin</h4>
                                <span>Project Manager</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 d-flex align-items-stretch">
                        <div class="member" data-aos="fade-up" data-aos-delay="300">
                            <div class="member-img">
                                <img src="assets/images/team/team-4.jpg" class="img-fluid" alt=""/>
                            </div>
                            <div class="member-info">
                                <h4>Scott Curtis</h4>
                                <span>Accountant</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </section>
            <section id="skills" class="skills">
                <div class="container">
                    <div class="section-title" data-aos="fade-up">
                        <h2>Our <strong>Skills</strong></h2>
                        <p>We bring together deep expertise in civil, structural, and infrastructure engineering to deliver projects that are safe, durable, and cost-effective. Our team combines technical precision with practical experience, ensuring every design meets the highest standards of quality and compliance. From concept to construction, we focus on innovation, sustainability, and client satisfaction in every project we undertake.</p>
                    </div>
                    <div class="row skills-content">
                        <div class="col-lg-6" data-aos="fade-up">
                            <div class="progress">
                                <span class="skill">Structural Design & Analysis <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Geotechnical Engineering <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Water & Drainage Systems <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Bridge & Infrastructure Engineering <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Construction Supervision & Quality Control <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Building Renovation & Retrofit <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                            <div class="progress">
                                <span class="skill">Project Management & Consultancy <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">MEP Integration (Mechanical, Electrical, Plumbing, HVAC) <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Permit & Regulatory Compliance <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                            <div class="progress">
                                <span class="skill">Industrial & Commercial Projects <i class="val">100%</i></span>
                                <div class="progress-bar-wrap">
                                    <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
        <Footer/>
    </div>
)
};

export default AboutUs;
